export default "__VITE_ASSET__gi8PrLST__"